/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_PrimaryInputs */

const cs_requirements_primary = /** @type {(inputs: Requirements_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hlavní`)
};

const en_requirements_primary = /** @type {(inputs: Requirements_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

/**
* | output |
* | --- |
* | "Primary" |
*
* @param {Requirements_PrimaryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_primary = /** @type {((inputs?: Requirements_PrimaryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_PrimaryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_primary(inputs)
	return cs_requirements_primary(inputs)
});